import { PageLayoutsContainer } from '@wajeez-web/components/layouts';

import { ExpectedToBeLostPremiumsChart } from '../components/PaymentCharts';

const PredectedAnalysisPage = () => {
  return (
    <PageLayoutsContainer
      title={`Predicted Analysis`}
      withoutRightPadding={false}
    >
      <div className="space-y-6 ">
        <div className="grid grid-cols-2  gap-4">
          <ExpectedToBeLostPremiumsChart />
        </div>
      </div>
    </PageLayoutsContainer>
  );
};

export default PredectedAnalysisPage;
